import { LoadingOutlined } from '@ant-design/icons'
import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { useDirectiveContext } from '@components/Reports/DispatchDirective/DirectiveContext'
import { handleAllocationsSave } from '@components/Reports/DispatchDirective/util'
import { addCommasToNumber, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import moment from 'moment'
import React, { useState } from 'react'

import { PaceMetric } from '../PaceMetric'
import { ClickTextEdit } from './ClickTextEdit'

export function MonthlyRow({ directive, updateRow, setIsExpanded }) {
  const [isRefreshing, setIsRefreshing] = useState(false)
  const { scopes } = useSecurityContext()
  const { selectedDate } = useDirectiveContext()
  const canEditDirectives =
    scopes.supply_directive.supply_view.edit && moment(selectedDate).isAfter(moment().startOf('day'))
  const onSave = (e) =>
    handleAllocationsSave(e.target.value, directive, 'monthly_percent', updateRow, setIsRefreshing, setIsExpanded)
  return (
    <Horizontal height={45}>
      <Vertical flex={1}>
        <Horizontal>
          <Vertical flex={1}>
            {isRefreshing ? (
              <Texto weight={600} className='flex' appearance='secondary'>
                <LoadingOutlined className='mr-2' /> Refreshing
              </Texto>
            ) : (
              <Texto weight={500} align='right' category='h6'>
                {addCommasToNumber(directive.monthly_allocation, 0)}
              </Texto>
            )}
          </Vertical>
          <Vertical flex={1}>
            {canEditDirectives ? (
              <ClickTextEdit
                display={
                  <Texto weight={500} align='right' category='h6' className='pr-2'>
                    {addCommasToNumber(directive.monthly_percent * 100, 0)}%
                  </Texto>
                }
                onSave={onSave}
                defaultValue={addCommasToNumber(directive.monthly_percent * 100, 0)}
              />
            ) : (
              <Texto weight={500} align='right' category='h6' className='pr-2'>
                {addCommasToNumber(directive.monthly_percent * 100, 0)}%
              </Texto>
            )}
          </Vertical>
          <Vertical className='pr-4' flex={1}>
            <Texto weight={500} align='right' category='h6'>
              {addCommasToNumber(directive.monthly_start_allocation, 0)}
            </Texto>
          </Vertical>
        </Horizontal>
      </Vertical>
      <Vertical flex={1}>
        <Tooltip title='Allocation Pace (Maximum)'>
          <div>
            <PaceMetric
              value={directive.allocation_pace || 0}
              loaded={directive.loaded}
              allocation={directive.monthly_start_allocation}
              letter='A'
              type='compact'
            />
          </div>
        </Tooltip>
        <Tooltip title='Contract Pace (Minimum)'>
          <div>
            <PaceMetric
              value={directive.contract_pace || 0}
              loaded={directive.loaded}
              allocation={directive.active_contract_volume}
              type='compact'
              letter='C'
              isContract
            />
          </div>
        </Tooltip>
      </Vertical>
    </Horizontal>
  )
}
